import ACEWINFISHActions from './ACEWINFISHActions'

export default class ACEWINSLOTActions extends ACEWINFISHActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'SLOT',
      gameName: 'Cake Bonanza',
      gameCode: 'ACEWIN-SLOT-025',
      platform: 'ACEWIN',
    }

    // txnId & roundId: 100012769734
    // betTime: 2025-09-23T15:04:42.000+08:00
  }
}
